<div class="fy">
  <div class="fy-intro">
    <p class="fy-eyebrow">For you</p>
    <h2 class="fy-title">Newly listed, in the corners you follow.</h2>
    <p class="fy-sub">
      Every card below is here for a reason, and the reason is always shown.
    </p>
  </div>

  <!-- Interests control (minimal, user-facing) -->
  <div class="fy-interests">
    <span class="fy-interests-label">Your interests:</span>
    <span class="fy-chip" *ngFor="let i of interests">
      {{ i.value }} <span class="fy-chip-type">{{ i.type }}</span>
      <button type="button" class="fy-chip-x" (click)="removeInterest(i.id)" aria-label="Remove">×</button>
    </span>
    <span class="fy-interests-none" *ngIf="interests.length === 0">none yet — add one to see matches</span>
    <span class="fy-add">
      <select [(ngModel)]="newType" aria-label="Interest type">
        <option *ngFor="let t of interestTypes" [value]="t">{{ t }}</option>
      </select>
      <input [(ngModel)]="newValue" (keydown.enter)="addInterest()" placeholder="e.g. HS, JAMES, 1, dateless" />
      <button type="button" class="fy-add-btn" (click)="addInterest()">Add</button>
    </span>
  </div>

  <!-- For You cards (LIVE: GET /account/for-you) -->
  <ng-container *ngIf="forYou">
    <div class="fy-cards" *ngIf="forYou.cards.length > 0; else quiet">
      <a class="fy-card" *ngFor="let card of forYou.cards" [routerLink]="plateUrl(card.registration)">
        <span class="fy-strength" [class.related]="card.matchStrength === 'related'">
          {{ card.matchStrength === 'exact' ? 'Match' : 'Related' }}
        </span>
        <span class="fy-card-plate">
          <pla-plate [rawPlate]="card.formattedRegistration || card.registration" [showPrice]="false" [openModal]="false"
            [clickThrough]="false" [center]="false" [mobileSmall]="true" [customClass]="'flat shaded'"></pla-plate>
        </span>
        <span class="fy-card-body">
          <span class="fy-card-because">{{ becauseLine(card.reason) }}</span>
          <span class="fy-card-also" *ngIf="otherReasons(card).length">Also matches {{ otherReasons(card).join(' and ') }}</span>
          <span class="fy-card-price" *ngIf="priceLabel(card)">{{ priceLabel(card) }}</span>
          <span class="fy-card-auction" *ngIf="card.auction">
            {{ card.auction.title || card.auction.house }}<ng-container *ngIf="card.auction.daysRemaining != null">
              · {{ card.auction.daysRemaining }} day{{ card.auction.daysRemaining === 1 ? '' : 's' }} to go</ng-container>
          </span>
        </span>
      </a>
    </div>
    <ng-template #quiet>
      <p class="fy-quiet">
        {{ interests.length === 0
          ? 'Add an interest above to see matching plates from live auctions.'
          : 'No live auction lots match your interests right now. We\'ll surface them as catalogues publish.' }}
      </p>
    </ng-template>
  </ng-container>
  <p class="fy-quiet" *ngIf="failed">For You is unavailable right now.</p>
</div>
